import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-6 h-6"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M15.75 19.5L8.25 12l7.5-7.5"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "flex-grow overflow-x-scroll overflow-y-hidden pb-4 tracking-wider" }
const _hoisted_5 = { ref: "firstElementNode" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src", "srcset", "alt"]
const _hoisted_8 = ["src", "srcset", "alt"]
const _hoisted_9 = { ref: "lastElementNode" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-6 h-6"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M8.25 4.5l7.5 7.5-7.5 7.5"
  })
], -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showAll !== 'true')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "flex-shrink h-full pt-5 text-gray-400 cursor-pointer",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollFirst && _ctx.scrollFirst(...args)))
        }, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass(["relative z-0 flex min-w-min justify-center", { 'flex-wrap': _ctx.showAll === 'true' }])
      }, [
        _createElementVNode("div", _hoisted_5, null, 512),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.values, (valueText, valueIdx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: 'value' + valueIdx,
            class: "relative mr-1 mb-1 w-20 cursor-pointer text-center",
            onClick: ($event: any) => (_ctx.toggleParameter(valueIdx))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["rounded-full w-16 h-16 mx-auto my-auto overflow-y-hidden cursor-pointer", {
              '': !_ctx.parameter.includes(valueIdx),
              'border-2 border-brand-main': _ctx.parameter.includes(valueIdx),
            }])
            }, [
              (_ctx.filterId === 'form')
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: 
                _ctx.Images.get(
                  '/img/filter/form/' + valueIdx.toLowerCase() + '@1x.png'
                )
              ,
                    srcset: 
                _ctx.Images.get(
                  '/img/filter/form/' + valueIdx.toLowerCase() + '@2x.png'
                )
              ,
                    class: "w-16 h-16 mx-auto my-auto",
                    alt: valueIdx.toLowerCase()
                  }, null, 8, _hoisted_7))
                : (_ctx.filterId === 'color')
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: 
                _ctx.Images.get(
                  '/img/filter/color/' + valueIdx.toUpperCase() + '@1x.jpg'
                )
              ,
                      srcset: 
                _ctx.Images.get(
                  '/img/filter/color/' + valueIdx.toUpperCase() + '@2x.jpg'
                )
              ,
                      class: "w-16 h-16 mx-auto my-auto",
                      alt: valueIdx.toLowerCase()
                    }, null, 8, _hoisted_8))
                  : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("span", {
              class: _normalizeClass(["w-full text-xs text-center font-light text-gray-400 cursor-pointer", {
              '': !_ctx.parameter.includes(valueIdx),
              'font-bold text-brand-main': _ctx.parameter.includes(valueIdx),
            }])
            }, _toDisplayString(_ctx.$t("searchForm.parts." + _ctx.filterId + ".types." + valueIdx)), 3)
          ], 8, _hoisted_6))
        }), 128)),
        _createElementVNode("div", _hoisted_9, null, 512)
      ], 2)
    ]),
    (_ctx.showAll !== 'true')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "flex-shrink h-full pt-5 text-gray-400 cursor-pointer",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.scrollLast && _ctx.scrollLast(...args)))
        }, _hoisted_11))
      : _createCommentVNode("", true)
  ]))
}